module.exports = __webpack_public_path__ + "img/arrow-square-down-right.79dd6d97.svg";